import { Link } from 'components/basic/link';
import { RSI_PORTAL_URL } from 'constants/constants';
import styled from 'styled-components';

const ButtonArea = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin: 10px 20px;
`;

export const WorkflowListButtonArea = () => {
  return (
    <ButtonArea>
      <Link url={RSI_PORTAL_URL} target="_blank">
        共通設定サイトでWFアプリの設定を行う
      </Link>
    </ButtonArea>
  );
};
